import { AxiosResponse } from 'axios';
import bus from '../bus';

import messagesStore from '@/core/messages/messages.store';
import { ClientMessage } from '@/b2b/shared/api/server-apis';

export default (response: AxiosResponse) => {
    const messages = response.data?.messages;
    if (messages) {
        // Validation-messages received. If a messagesId is included (from a post) forward messages to local handler
        // If no messagesId or no one wanted to handle, show globally.
        const messagesId: string | undefined = (response.config as any)?.messagesId;
        let isHandled = false;
        if (messagesId) {
            bus.emit(ValidationErrorEventKey, {
                messagesId,
                messages: messages,
                handled: () => (isHandled = true),
            } as ValidationErrorEvent);
        }

        if (!isHandled) {
            messagesStore.addApiMessages(messages);
        }

        messagesStore.logCustomApiMessages(messages);
    }
    return response;
};

export const ValidationErrorEventKey = 'ValidationError';

export interface ValidationErrorEvent {
    messagesId: string;
    messages: ClientMessage[];
    handled: () => void;
}
